export default __webpack_public_path__ + "static/130-min-min-6929cbb5b5b14bd5dff7ea4cb2397d4e.jpg";